import { Component, OnInit } from '@angular/core';
import { Layout } from 'src/app/core/classes/layout';
import { ILayout } from 'src/app/core/models/layout.vm';

@Component({
  selector: 'app-project-monitoring-tool',
  templateUrl: './project-monitoring-tool.component.html',
  styleUrls: ['./project-monitoring-tool.component.scss']
})
export class ProjectMonitoringToolComponent implements OnInit {

  public layout: ILayout;

  constructor() { }

  ngOnInit(): void {
    this.layout = new Layout('Project Monitoring Tool', null, '/tool');
  }

}
